import { ModalDsl, ModalName, ModalSize, SettingsProvider } from '../../../types';
import { SectionFactory } from '../section';

export type ModalDslOptions = {
  title: string;
  size: ModalSize;
  sections: SectionFactory[];
  settingsProvider?: SettingsProvider;
  name: ModalName;
};

export class ModalDslFactory {
  constructor(private readonly options: ModalDslOptions) {}

  build(): ModalDsl {
    const { title, size, sections, settingsProvider, name } = this.options;
    return {
      title,
      size,
      name,
      sections: sections.map(s => s._build()),
      settings: settingsProvider || {
        values: {},
        dataSettings: [],
        metadata: {},
      },
    };
  }
}
